import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import _ from 'lodash'

const initialState: any = 1

const currentStepSlice = createSlice({
  name: 'currentStep',
  initialState,
  reducers: {
    changeStep: (state, action: PayloadAction<any>) => {
      return action.payload
    },
  },
  extraReducers: () => {},
})

export const currentStepActionsCreator = currentStepSlice.actions

export default currentStepSlice
